import * as React from 'react';
import { MessageBar, MessageBarType, Stack, Text } from '@fluentui/react';

export * from './types';
export * from './helpers';
export * from './hooks';
export * from './questionsApi';
export * from './proposedChangesApi';
export * from './questions/AgentTaskQuestionComponents';

export function SyntheticBanner({ visible }: { visible: boolean }) {
    if (!visible) {
        return null;
    }

    return (
        <MessageBar messageBarType={MessageBarType.warning}>
            Agent Task Manager is running in synthetic test mode. Data and flame graphs are generated for UX testing.
        </MessageBar>
    );
}

export function PageShell({ title, children }: { title?: string; children: React.ReactNode }) {
    return (
        <div className="page-container" style={{ paddingBottom: 24 }}>
            <Stack tokens={{ childrenGap: 16 }}>
                {title && <Text variant="xxLarge">{title}</Text>}
                {children}
            </Stack>
        </div>
    );
}

export function StatCard({ title, value, subtitle }: { title: string; value: string; subtitle?: string }) {
    return (
        <div
            style={{
                minWidth: 180,
                padding: 16,
                border: '1px solid #e1dfdd',
                borderRadius: 8,
                background: '#ffffff',
            }}
        >
            <Text variant="medium" styles={{ root: { color: '#605e5c' } }}>{title}</Text>
            <div style={{ fontSize: 28, fontWeight: 600, marginTop: 8 }}>{value}</div>
            {subtitle && (
                <Text variant="small" styles={{ root: { color: '#605e5c' } }}>{subtitle}</Text>
            )}
        </div>
    );
}
